import { render, staticRenderFns } from "./FilialeIndex.vue?vue&type=template&id=39520b91&scoped=true&"
import script from "./FilialeIndex.vue?vue&type=script&lang=js&"
export * from "./FilialeIndex.vue?vue&type=script&lang=js&"
import style0 from "./FilialeIndex.vue?vue&type=style&index=0&id=39520b91&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "39520b91",
  null
  
)

export default component.exports